import { RouterTypes } from 'router/types';

type PageLocation = Pick<Location, 'origin' | 'pathname'>;

type CanonicalRouting = {
  basePath?: string;
  routerType?: string;
};

/** `data-base-path` as the browser router mounts it: leading slash, no trailing slash, '' for the root. */
const toBasePath = (basePath = ''): string => {
  const trimmed = basePath.replace(/^\/+|\/+$/g, '');
  return trimmed ? `/${trimmed}` : '';
};

/**
 * The page a listing's canonical URL is built on: the page the visitor is on, as the browser loaded it
 * (origin + path, no query or fragment). Deliberately NOT the brand's saved sitemap URL: that value is
 * operator-entered and often differs from the served page by a trailing slash or a stale path, and a
 * canonical naming a URL that redirects (or a different page) gives Google contradictory signals on every
 * listing. The current page is always a URL that answered 200; the sitemap still reads the saved value.
 *
 * In browser mode the route lives in the path (`/experiences/e/<slug>`), so the page is the origin plus the
 * router's base path, with the route after it left off for the caller to append.
 */
const deriveCanonicalBase = (
  location: PageLocation = document.location,
  { basePath, routerType }: CanonicalRouting = {},
): string =>
  routerType === RouterTypes.BROWSER
    ? `${location.origin}${toBasePath(basePath)}`
    : `${location.origin}${location.pathname}`;

export default deriveCanonicalBase;
